module.exports = __webpack_public_path__ + "static/media/ic_previous.7a2f3f59.svg";